import { render, staticRenderFns } from "./error.vue?vue&type=template&id=1c83b0fe&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
import style0 from "./error.vue?vue&type=style&index=0&id=1c83b0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c83b0fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppSection: require('/builds/gb-developers/geekbrains-client/components/global/AppSection.vue').default})
